<template>
    <div class="footer">
        
        <div class="container">

            <div class="toggle" @click="toggle()">
                <i class="far fa-book fa-fw" />
                <span v-if="show">
                    Skjul ordforklaring
                    <i class="far fa-chevron-up fa-fw" />
                </span>
                <span v-else>
                    Vis ordforklaring
                    <i class="far fa-chevron-down fa-fw" />
                </span>
            </div>
            
            <div class="explainer" v-show="show">

                <div class="lines">
                    <div class="line" v-for="line in abbreviations" :key="line.abb">
                        <div class="abb">
                            {{ line.abb }}
                        </div>
                        <div class="exp">
                            {{ line.exp }}
                        </div>
                        <div class="comment">
                            {{ line.comment }}
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .footer {

        .container {
            text-align: center;

            .toggle {
                display: inline-block;
                margin: 0 auto;
                cursor: pointer;
                margin-bottom: $margin--main;
                border-bottom: 1px solid transparent;

                &:hover {
                    border-bottom: 1px solid $color--dark;
                }
            }

            .explainer {
                font-size: $fontsize--sm;
                background: $color--white;
                max-width: 800px;
                padding: $padding--main;
                box-shadow: $boxshadow--creative;
                margin: 0 auto $margin--main auto;
                text-align: left;

                .lines {

                    .line {
                        display: flex;

                        .abb {
                            flex: 0 0 15%;
                            font-weight: 700;
                        }

                        .exp {
                            flex: 0 0 35%;
                            padding-left: $padding--main;
                        }

                        .comment {
                            flex: 0 0 50%;
                            padding-left: $padding--main;
                        }

                        &:not(:last-of-type) {
                            margin-bottom: $margin--small;
                        }
                    }
                }
            }
        }
    }

</style>

<script>
export default {
    data () {
        return {
            show: false,
            abbreviations: [
                {
                    abb: 'EBITDA',
                    exp: 'Resultatet før renter, skat, afskrivninger og nedbringelse af gæld',
                    comment: 'EBITDA er virksomhedens driftsoverskud. Med andre ord viser EBTIDA, hvor stærk en “motor” virksomheden har til at kunne betale renter, afbetale på gæld og mindst lige så vigtig at skabe overskud til virksomhedens ejer. EBITDA er også en væsentligt indikator for, hvor meget virksomheden er værd. Hvor meget vil du betale for en virksomhed, der har et driftsoverskud på 300.000 kr.? Hvis virksomheden sælges for f.eks. 1.500.000 kr., vil det tage 5 år, inden investeringen er kommet hjem. For hver krone EBTIDA øges, vil virksomheden stige i værdi.'
                },
                {
                    abb: 'DB',
                    exp: 'Dækningsbidrag',
                    comment: 'Dækningsbidraget er et udtryk for, hvor stort et beløb der er tilbage på en opgave, når de direkte omkostninger er afholdt (lønninger, materialer). Dækningsbidrag er dermed lig overskud pr. opgave.'
                },
                {
                    abb: 'DG',
                    exp: 'Dækningsgrad',
                    comment: 'Dækningsgraden er et udtryk for hvor meget dit overskud pr. opgave udgør i % af den samlede omsætning på en opgave. Hvis du eksempelvis har opnået et overskud på 2.000 kr på en opgave til 4.000 kr vil din DG være 50 (50%).'
                },
                {
                    abb: 'DB pr. time',
                    exp: 'Dækningsbidrag pr. time',
                    comment: 'Dækningsbidraget pr. time er et udtryk for dækningsbidraget divideret med antal timer brugt. Dvs. hvor "effektive" svendene har været. DB. pr time er dermed lig overskud pr. time.'
                }
            ]
        }
    },
    methods: {
        toggle () {
            this.show = !this.show
        }
    }
}
</script>



// WEBPACK FOOTER //
// footer.vue?f442027a